import { Component, OnInit, ElementRef, ViewChild, Input, EventEmitter, HostListener, Renderer2, ChangeDetectorRef, AfterViewInit } from '@angular/core';

import { BehaviorSubject, Subscription, Observable, of } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FiltersPipe } from '@pipes/filters.pipe';
import { TranslatePipe } from '@pipes/translate.pipe';
import { GroupBySportId } from '@pipes/groupbysportid';
import { GroupByTournamentId } from '@pipes/grouplivefixturebytournamentid';
import { WebWorkerService } from '../modules/workers/web-worker.service';

@Component({
  selector: 'home-live',
  templateUrl: '../sharedTemplates/home-live.component.html',
})
export class HomeLiveComponent implements AfterViewInit {
  public liveFilterSelectedSportId;
  _selectedOdds: OddModel[] = [];
  liveMatchList = [];
  oldLiveMatchList = [];
  cardList = [];
  translator = new TranslatePipe(this._LocalizationService);

  storySportsData = this._DataHelper.storySportsData;
  oddLiveMarketingValue = [0];
  isInitialized = false;
  liveMatchobservable = new BehaviorSubject<any>([]);

  private subscriptionsToStopOnDestroy: Subscription[] = [];

  _FiltersPipe = new FiltersPipe(this._LocalizationService);
  _GroupByTournamentId = new GroupByTournamentId();
  _GroupBySportId = new GroupBySportId();
  _liveFilterItems;
  // Result Live Data
  __ResultLiveData;
  __ResultLiveFavsData;
  contentHeight;
  othersHeight;
  matchFilterBySportKey = '';
  isHeaderShow = true;

  fullmatch: Observable<any[]>;

  @HostListener('window:resize', ['$event'])
  onResize() {
    // used windopw-innerWidth
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }
  constructor(
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    private _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _LocalizationService: LocalizationService,
    public _LZ: LocalizationService,
    private cdRef: ChangeDetectorRef,
    private _SignalRService: SignalrServiceLegacy,
    private _webWorkerService: WebWorkerService
  ) {}

  ngAfterViewInit() {
    // If connection is not exists
    if (!this._SignalRService.connectionExists) {
      this.subscriptionsToStopOnDestroy.push(
        this._SignalRService.connectionEstablished.subscribe(x => {
          // ////console.log("canlı bağlandı detayda : ", x);
          this.connectHub();
        })
      );
    } else {
      this.connectHub();
    }

    //Daha önce seçilen oddları tekrar seçsin
    this.subscriptionsToStopOnDestroy.push(
      this._ApiService.selectedOddsEvent.subscribe(x => {
        this._selectedOdds = x as OddModel[];
      })
    );
    this._ApiService.getSelectedOdds();

    this._UiHelper.setNavbarTitle('', true, false);

    this.heightsetter(this._UiHelper.windowsHeight);
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.windowResized.subscribe(x => {
        this.heightsetter(x.h);
      })
    );
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.contentHeightListener.subscribe(x => {
        this.othersHeight = x;
      })
    );
  }
  heightsetter(c) {
    this.contentHeight = c - 252;
    this.contentHeight += 'px';
    ////console.log('Content Height : ', this.contentHeight, c, this.othersHeight);
  }
  connectHub() {
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.liveDataListener.subscribe(y => {
        this.oldLiveMatchList = this.liveMatchList;
        this.liveMatchList = y;
        this.liveMatchobservable.next(this.liveMatchList);
        this.cdRef.detectChanges();
        this.dataRebuild();
      })
    );

    this.liveMatchobservable.next(this._DataHelper.liveData);
    this.liveMatchList = this._DataHelper.liveData;
    this.oldLiveMatchList = this.liveMatchList;

    // Kırmızı Kart datası => GetTerminalLiveFixture içinde gönderiliyor artık ihtiyaç yok
    // this.cardList = this._DataHelper.cardData;
    // this.subscriptionsToStopOnDestroy.push(
    // this._DataHelper.cardDataListener.subscribe(y => {
    //   this.cardList = y;
    //   // ////console.log("CARD", y);
    // }));

    this._liveFilterItems = this._DataHelper.liveFilterItems;
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.liveFilterItemsListener.subscribe(x => {
        this._liveFilterItems = x;
        this.dataRebuild();
      })
    );
    this.dataRebuild();
    this.cdRef.detectChanges();

    this._SignalRService.readUpdatedEvents();
  }

  dataRebuild() {
    const wwsConfig = {
      langCode: this._LocalizationService.LANGCODE,
      lml: this.liveMatchList,
      old_lml: this.oldLiveMatchList,
      mfbysk: this.matchFilterBySportKey,
      lfi: this._liveFilterItems,
      cardList: this.cardList, // CARD
      oddtype: this.oddLiveMarketingValue,
      favorable: this._UserHelper.favoriedMatches,
      isLive: true,
      liveSortbyTime: false,
    };

    if (this.liveMatchList === undefined) {
      return;
    }
    const promise = this._webWorkerService.run(this._DataHelper.webWorkerLiveJob, wwsConfig).then(result => {
      this.__ResultLiveData = result.dt && result.dt.slice(0, 10);
      // League Filter
      this._DataHelper.setLiveEventRebuildedUnfiltered(this._GroupByTournamentId.transform(result.dtUn, null));

      const Obsobj = of(this.__ResultLiveData);
      this.fullmatch = Obsobj;
      // League Filter
      this.isInitialized = true;
      // Fav Data
      this.__ResultLiveFavsData = result.dtFavs;
      this.cdRef.detectChanges();
    });
  }

  oddLiveMarketingChange(e) {
    this.oddLiveMarketingValue[0] = e;
    this.dataRebuild();
    ////console.log('E', e);
  }
  goLiveEventDetail(e) {
    // this._Router.navigate(['/eventdetail'], { queryParams: { eventID: e } });
    this._Router.navigate(['/liveeventdetail', e]);
    //////console.log('e', e);
  }

  matchFilterBySport(e) {
    // this.matchFilterBySportKey = e;
    // //console.log('matchFilterBySport :', e);

    if (e) {
      if (e.sportName) {
        this.matchFilterBySportKey = e.sportName;
      }
      if (e.sportId) {
        this.liveFilterSelectedSportId = e.sportId;
      }
    }

    this._liveFilterItems = [];
    this._DataHelper.setLiveFilterItems(this._liveFilterItems);
    this.dataRebuild();
  }

  morelive() {
    this._Router.navigate(['/live']);
  }

  onlyMatches() {
    this.isHeaderShow ? (this.isHeaderShow = false) : (this.isHeaderShow = true);
  }
  favsChanged() {
    // Rebind Favs
    this.dataRebuild();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }
}
export class OddModel {
  constructor(OddId: number) {
    this.OddId = OddId;
  }

  OddId: number;
}
